import {CollectionViewer, DataSource} from "@angular/cdk/collections";
import {BehaviorSubject, Observable} from "rxjs";

export class BaseDatasource<T> implements DataSource<any> {
  tableSubject = new BehaviorSubject<T[]>([]);
  pageSizeSelect = [5, 10, 20, 30, 40, 50];
  totalPage: number = 5;
  hasItems: boolean = true;
  current_page: number = 0;
  pageSize: number = 5;
  totalItem: number = 10;
  totalItem$= new BehaviorSubject<number>(0)
  isPreloadTextViewedSubject = new BehaviorSubject<boolean>(false);

  public isFinishLoadingSubject = new BehaviorSubject<boolean>(false);
  public finishLoading = this.isFinishLoadingSubject.asObservable();
  public isTableLoaded = false

  paginatorTotal$: Observable<number>;
  constructor() {
    // super();
    this.finishLoading.subscribe(value => {
      this.isTableLoaded=value;
    })
  }

  connect(collectionViewer: CollectionViewer): Observable<T[] | ReadonlyArray<T>> {
    return this.tableSubject;
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.tableSubject.complete();
  }

}
